import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { Button } from 'components/UI/Button'
import { ContentBlock } from 'components/common'
import { Row, Col } from 'styled-bootstrap-grid'

import AmountItem from './AmountItem'
import { history, routePath } from '../../../routes'
import { Redirect } from 'react-router-dom'
import { InfoLink } from '../../UI/CompactTable/ListItem/styles'
import Modal from '../../UI/Modal'

import Collapsible from 'react-collapsible'
// import Link from 'components/UI/Link'

interface Props {
  data: any
  onDownloadClick: () => void
  onPrintClick: () => void
  onEmailClick: () => void
  isAdmin: boolean
  isFetching: boolean
  isAuthenticated?: boolean
}
// interface State {
//   isAdmin: boolean
// } //State
interface State {
  showModal: boolean
  errorModal: boolean
  modalContent: string
}
class EstimateInfo extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      showModal: false,
      errorModal: false,
      modalContent: ''
    }
  }

  // componentDidUpdate(prevProps: Props, prevState: State) {
  //   if (prevProps.isAdmin !== this.state.isAdmin) {
  //     this.setState({ isAdmin: this.props.isAdmin })
  //   }
  // }

  onShowModal = () => this.setState({ showModal: true })
  onCloseModal = () => this.setState({ showModal: false })

  onShowErrorModal = () => this.setState({ errorModal: true })
  onCloseErrorModal = () => this.setState({ errorModal: false })


  goToSignIn = () => {
    history.push(routePath.SIGN_IN)
    this.onCloseModal()
  }
  goToAccount = () => {
    history.push(routePath.CREATE_ACCOUNT)
    this.onCloseModal()
  }

  goToWizard = () => {
    history.push(routePath.ESTIMATE_CREATE)
    this.onCloseModal()
  }


  // tslint:disable-next-line:variable-name
  _renderCol = (label: string, value: string | number, xl: number, md: number) => (
    <Col xl={xl} md={md}>
      <Option>
        <Label>{label}</Label>
        <Value>{value}</Value>
      </Option>
    </Col>
  )

  redirectTo = () => {
    const {
      data: { id }
    } = this.props
    console.log('id', id)
    return <Redirect to={routePath.ESTIMATE_VIEW} />
  }

  render() {
    const {
      data,
      data: { id, memberId, firstName, lastName, physicianName, payer },
      isAdmin,
      isFetching,
      onDownloadClick,
      onPrintClick,
      onEmailClick,
      isAuthenticated
    } = this.props
    const { showModal, errorModal } = this.state

    const appoinmentNameList = !data.appointmentTypeEntityList || data.appointmentTypeEntityList.length === 0 ? undefined : data.appointmentTypeEntityList.map((item: any) => {
      return item.appointmentCode + ' ' + item.description
    })

    const appointmentType = !appoinmentNameList || appoinmentNameList.length === 0
      ? undefined
      : (appoinmentNameList.length === 1) ? appoinmentNameList[0] : appoinmentNameList.join(', ')

    const procedureNameList = !data.cpt4EntitySet ? undefined : data.cpt4EntitySet.map((item: any) => {
      return item.cpt4Code + ' ' + item.description
    })

    const procedureName = !procedureNameList
      ? undefined
      : (procedureNameList.length === 1) ? procedureNameList[0] : procedureNameList.join(', ')

    console.log("appointmentType", appointmentType === undefined, appoinmentNameList)
    console.log("procedureName", procedureName === undefined, procedureNameList)

    const hasDependentEntity =
      data.dependentEntity !== undefined &&
      data.dependentEntity.firstName !== undefined &&
      data.dependentEntity.lastName !== undefined &&
      data.dependentEntity.gender !== undefined
    const patientName = !hasDependentEntity
      ? `${firstName} ${lastName}`
      : `${data.dependentEntity.firstName} ${data.dependentEntity.lastName}`
    const createdAt = new Date(data.createdAt).toLocaleString('en', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
    let viewDobFormat = !hasDependentEntity ? data.dob : data.dependentEntity.dob
    const [y, m, d] = viewDobFormat ? viewDobFormat.split('-') : '00-00-0000'.split('-')
    if (typeof (m) !== 'undefined' || typeof (d) !== 'undefined') {
      viewDobFormat = `${m}/${d}/${y}`
    }

    const dob = viewDobFormat
    //   new Date(
    //   !hasDependentEntity ? data.dob : data.dependentEntity.dob
    // ).toLocaleString('en', {
    //   year: 'numeric',
    //   month: 'long',
    //   day: 'numeric'
    // })

    const gender = !hasDependentEntity
      ? data.gender
      : data.dependentEntity.gender

    const totalCharges =
      data.totalCharges !== undefined &&
      getFormattedNumber(data.totalCharges.toString())
    const deductible =
      data.deductible !== undefined &&
      getFormattedNumber(data.deductible.toString())
    const copay =
      data.copay !== undefined && getFormattedNumber(data.copay.toString())
    const coInsurance =
      data.coInsurance !== undefined &&
      getFormattedNumber(data.coInsurance.toString())
    const allowedAmount =
      data.allowedAmount !== undefined &&
      getFormattedNumber(data.allowedAmount.toString())
    const maxOutOfPocket =
      data.maxOutOfPocket !== undefined &&
      getFormattedNumber(data.maxOutOfPocket.toString())
    const responsibility =
      data.patientResponsibility !== undefined &&
      getFormattedNumber(data.patientResponsibility.toString())

    const tierEnabled = data.estimationTieringResponseEntity !== undefined

    const tierDeductible =
      data.estimationTieringResponseEntity !== undefined && data.estimationTieringResponseEntity.deductible !== undefined &&
      getFormattedNumber(data.estimationTieringResponseEntity.deductible.toString())

    const tierCopay =
      data.estimationTieringResponseEntity !== undefined && data.estimationTieringResponseEntity.copay !== undefined &&
      getFormattedNumber(data.estimationTieringResponseEntity.copay.toString())

    const tierCoInsurance =
      data.estimationTieringResponseEntity !== undefined && data.estimationTieringResponseEntity.coInsurance !== undefined &&
      getFormattedNumber(data.estimationTieringResponseEntity.coInsurance.toString())

    const tierResponsibility =
      data.estimationTieringResponseEntity !== undefined && data.estimationTieringResponseEntity.patientResponsibility !== undefined &&
      getFormattedNumber(data.estimationTieringResponseEntity.patientResponsibility.toString())

    const tierMaxOutOfPocket =
      data.estimationTieringResponseEntity !== undefined && data.estimationTieringResponseEntity.maxOutOfPocket !== undefined &&
      getFormattedNumber(data.estimationTieringResponseEntity.maxOutOfPocket.toString())

    console.log("Active coverage is", data.activeCoverage);
    const activeCoverage = data.activeCoverage !== undefined && data.activeCoverage
    const isSelfPay = payer.fakeEligibility || "self-pay" === payer.carrierName.toLowerCase();
    console.log(data)
    return (
      <WrapBlock>
        <HeadTitle>
          <Title>Your Estimate</Title>
          {isAdmin ? (
            <Links>
              {/*<LinkDelete>Delete</LinkDelete>*/}
              <InfoLink to={`/estimates/edit/${id}`}>
                <ButtonLink>Edit</ButtonLink>
              </InfoLink>
            </Links>
          ) : (
              <Links>
                <Link onClick={onDownloadClick}>Download</Link>
                <Link onClick={onPrintClick}>Print</Link>
                <Link onClick={onEmailClick}>Email</Link>
              </Links>
            )}
        </HeadTitle>
        <ContentBlock>
          <ContentTitle>
            <h2>Estimate #{id}</h2>
            <span>Date Created: {createdAt}</span>
          </ContentTitle>
          <Divider />
          <Row>
            {this._renderCol('Patient', patientName, 4, 6)}
            {memberId && this._renderCol('Member ID', memberId, 4, 6)}
            {dob && !isSelfPay && this._renderCol('DOB', dob, 4, 6)}
            {gender && this._renderCol('Gender', gender, 4, 6)}
            {appointmentType !== undefined &&
              this._renderCol('Appointment Type', appointmentType, 8, 10)}
            {procedureName !== undefined && this._renderCol('Procedure', procedureName, 8, 10)}
            {physicianName === undefined ||
              this._renderCol('physician', physicianName, 4, 6)}
            {/* {this._renderCol('Service Code', '-')} */}
          </Row>

          <Collapsible
            open={true}
            trigger={<Link>Hospital Estimate Based on In-Network</Link>}
            triggerStyle={{ fontWeight: 'bold', marginBottom: '30px' }}>

            <ContentBlock>
              <Row>
                <Col xl={6} md={6}>
                  {totalCharges && (
                    <AmountItem
                      name={isSelfPay ? 'Standard Charge' : "Estimated Total Charges"}
                      value={`$${totalCharges}`}
                    />
                  )}
                </Col>

                <Col xl={6} md={6}>
                  {deductible && (
                    <AmountItem
                      name="Estimated Deductible"
                      value={`$${deductible}`}
                    />
                  )}
                </Col>

                <Col xl={6} md={6}>
                  {allowedAmount && (
                    <AmountItem
                      name="Estimated Allowed Amount"
                      value={`$${allowedAmount}`}
                    />
                  )}
                </Col>

                <Col xl={6} md={6}>
                  {copay && (
                    <AmountItem name="Estimated Co-Pay" value={`$${copay}`} />
                  )}
                </Col>

                <Col xl={6} md={6}>
                  {allowedAmount && (
                    <AmountItem
                      name=""
                      value=""
                    />
                  )}
                </Col>

                <Col xl={6} md={6}>
                  {coInsurance && (
                    <AmountItem
                      name="Estimated Co-Insurance"
                      value={`$${coInsurance}`}
                    />
                  )}
                </Col>

                <Col xl={6} md={6}>
                  {responsibility && (
                    <AmountItem
                      name={isSelfPay ? 'Discounted Cash Price' : "Estimated Responsibility"}
                      value={`$${responsibility}`}
                    />
                  )}
                </Col>

                <Col xl={6} md={6}>
                  {maxOutOfPocket && (
                    <AmountItem name="Maximum out of Pocket" value={`$${maxOutOfPocket}`} />
                  )}
                </Col>

              </Row>
            </ContentBlock>
          </Collapsible>

          {tierEnabled &&
            (<Collapsible
              trigger={<Link>Enhanced Tier Network</Link>}
              open={true}
              triggerStyle={{ fontWeight: 'bold', fontSize: 20 }}>

              <ContentBlock style={{ marginBottom: '30px' }}>
                <Row>
                  <Col xl={6} md={6}>
                  <AmountItem name="" value="" />
                  </Col>

                  <Col xl={6} md={6}>
                    {tierDeductible && (
                      <AmountItem
                        name="Estimated Deductible"
                        value={`$${tierDeductible}`}
                      />
                    )}
                  </Col>
                  
                  <Col xl={6} md={6}>
                  <AmountItem name="" value="" />
                  </Col>

                  <Col xl={6} md={6}>
                  {tierCopay && (
                    <AmountItem
                      name="Estimated Co-Pay"
                      value={`$${tierCopay}`}
                    />
                  )}
                  </Col>

                  <Col xl={6} md={6}>
                  <AmountItem name="" value="" />
                  </Col>

                  <Col xl={6} md={6}>
                  {tierCoInsurance && (
                    <AmountItem
                      name="Estimated Co-Insurance"
                      value={`$${tierCoInsurance}`}
                    />
                  )}
                  </Col>
                  
                  <Col xl={6} md={6}>
                  {tierResponsibility && (
                    <AmountItem
                      name="Estimated Responsibility - Enhanced Tier"
                      value={`$${tierResponsibility}`}
                    />
                  )}
                  </Col>

                  <Col xl={6} md={6}>
                  {tierMaxOutOfPocket && (
                    <AmountItem name="Maximum out of Pocket" value={`$${tierMaxOutOfPocket}`} />
                  )}
                  </Col>

                </Row>
              </ContentBlock>
            </Collapsible>)}

          <Divider />

          <BottomBlock>
            <Fragment>
              <Button
                variant={'default'}
                disabled={isFetching}
                onClick={onDownloadClick}
              >
                Download
                </Button>
              <Button
                variant={'default'}
                disabled={isFetching}
                onClick={onPrintClick}
              >
                Print
                </Button>
              <Button
                variant={'default'}
                disabled={isFetching}
                onClick={onEmailClick}
              >
                Email
                </Button>
            </Fragment>
          </BottomBlock>
        </ContentBlock>
        <Modal
          modal={{
            title: 'Save Estimate',
            content: (
              <div>
                <span>You can save the estimate, generate new ones and more by creating a free account.</span>
              </div>
            ),
            footer: (
              <ModalButtonBlock>
                <Button variant={'default'} onClick={this.goToAccount}>
                  Create Account
                </Button>
                <Button
                  style={{ width: '100%' }}
                  variant={'text'}
                  onClick={this.goToSignIn}
                >
                  Or, Sign in
                </Button>
              </ModalButtonBlock>
            )
          }}
          isOpen={showModal}
        />

        <Modal
            modal={{
              title: 'Estimation Error',
              content: (
                <div>
                  <span>System could not contact insurance to validate your insurance. or active coverage was not returned by insurance.</span>
                  <span>Please confirm that personal and/or insurance information inputted is correct and try again.</span>
                </div>
              ),
              footer: (
                <ModalButtonBlock>
                  <Button variant={'default'} onClick={this.goToWizard}>
Retry Estimation
                  </Button>
                </ModalButtonBlock>
              )
            }}
            isOpen={errorModal || !activeCoverage || activeCoverage !== 'A' }
       />
      </WrapBlock>
    )
  }
}
// 
const getFormattedNumber = (numStr: string): string => {
  return parseFloat(numStr).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export default EstimateInfo

const WrapBlock = styled.div``

export const Option = styled.div`
  margin-bottom: 2rem;
`

export const Label = styled.p`
  color: #89919c;
  font-size: 14px;
`

export const Value = styled.p`
  color: #152735;
  font-size: 21px;
`

const Title = styled.h1`
  font-size: 30px;
  font-weight: 600;
  color: #152735;
  text-align: center;
  padding: 0;
`

const HeadTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2.5rem;
`

const ContentTitle = styled.div`
  margin-bottom: 30px;
  > span {
    font-size: 21px;
    color: #585d64;
    font-weight: 500;
    line-height: 50px;
  }
`

const Divider = styled.div`
  width: 100%;
  border: 0.5px solid #eeeeee;
  height: 0px;
  margin-bottom: 30px;
`

const Amounts = styled.div`
 /*  display: flex;
  flex: 1;
  justify-content: space-between;
  flex-wrap: wrap;
  > div {
    flex: 0 0 48%;
    margin-bottom: 20px;
  } */
 `

const BottomBlock = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  > button {
    margin-right: 20px;
  }
`

const Links = styled.div`
  display: flex;
  justify-content: flex-end;
`

const Link = styled.a`
  text-decoration: none;
  font-size: 16px;
  color: #41aada;
  font-weight: bold;
  cursor: pointer;
  :not(:last-child) {
    margin-right: 25px;
  }
`
const ButtonLink = styled.span`
  text-decoration: none;
  font-size: 16px;
  color: #41aada;
  font-weight: bold;
  cursor: pointer;
  :not(:last-child) {
    margin-right: 25px;
  }
`
const ModalButtonBlock = styled.div`
  //align-content: center;
  //align-self: center;
  //width: 100%;
  margin: auto;
`